import { SalesforcePromotionCountdown } from '~/lib/salesforce/types';

/** When the promotion's countdown ends, or null if it has none Salesforce still counts down. */
export const getPromotionCountdownEndTime = ({
    countdown,
}: SalesforcePromotionCountdown): number | null => {
    if (!countdown.isCountdownActive || !countdown.countdownEndDate) return null;

    const endTime = new Date(countdown.countdownEndDate).getTime();

    return Number.isNaN(endTime) ? null : endTime;
};
